"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _button = _interopRequireDefault(require("@kyruus/button"));
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const BookButton = /*#__PURE__*/(0, _base.default)(_button.default, process.env.NODE_ENV === "production" ? {
  target: "exyemor0"
} : {
  target: "exyemor0",
  label: "BookButton"
})(process.env.NODE_ENV === "production" ? {
  name: "d0jtqm",
  styles: "width:100%;white-space:nowrap"
} : {
  name: "d0jtqm",
  styles: "width:100%;white-space:nowrap/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Jvb2tpbmdCdXR0b24vc3R5bGVzLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHaUMiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQm9va2luZ0J1dHRvbi9zdHlsZXMuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IEJ1dHRvbiBmcm9tICdAa3lydXVzL2J1dHRvbic7XG5cbmNvbnN0IEJvb2tCdXR0b24gPSBzdHlsZWQoQnV0dG9uKWBcbiAgd2lkdGg6IDEwMCU7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBCb29rQnV0dG9uO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var _default = exports.default = BookButton;